import { useContext } from 'react';
import ThemeContext from "./useThemeProvider";
import { themeColors } from "../styles/colors";
export var ESystemTheme;

(function (ESystemTheme) {
  ESystemTheme["DARK"] = "dark";
  ESystemTheme["LIGHT"] = "light";
})(ESystemTheme || (ESystemTheme = {}));

export default function useTheme() {
  var theme = useContext(ThemeContext);
  var _theme$system = theme.system,
      system = _theme$system === void 0 ? 'light' : _theme$system,
      _theme$branding = theme.branding,
      branding = _theme$branding === void 0 ? 'brandingAmi' : _theme$branding;
  var mergeSystem = themeColors[system] ? system : 'light';
  var mergeBranding = themeColors[branding] ? branding : 'brandingAmi';
  return {
    system: mergeSystem,
    branding: mergeBranding,
    custom: theme.custom,
    isSyetemThemeDark: mergeSystem === ESystemTheme.DARK
  };
}